<template>
  <div>
    <div
      v-if="choreToggled"
      :class="!readOnly ? 'chore-cell-body' : 'chore-cell-toggle-body'"
    >
      <div class="chore-cell-top-container">
        <div class="chore-cell-title">{{ this.chore.name }}</div>
        <div v-if="this.readOnly == false" class="chore-cell-actions">
          <div class="chore-cell-action">
            <img
              @click="selDeleteChore = true"
              src="../../assets/DeleteActionGrey.svg"
            />
            <span class="tooltip">Delete</span>
          </div>
          <div class="chore-cell-action">
            <img @click="editChore" src="../../assets/EditActionGrey.svg" />
            <span class="tooltip">Edit</span>
          </div>
          <div class="chore-cell-action">
            <img @click="assignChore" src="../../assets/AssignActionGrey.svg" />
            <span class="tooltip">Assign</span>
          </div>
          <div class="chore-cell-action">
            <img @click="copyPublicLink" src="../../assets/file-copy.svg" />
            <span class="tooltip">Copy public link</span>
          </div>
        </div>
        <img
          @click="choreToggled = !choreToggled"
          v-if="readOnly"
          src="../../assets/activeToggleButton.svg"
        />
      </div>

      <div class="chore-cell-description">{{ this.chore.description }}</div>

      <div class="chore-room-internal-name">
        <img src="../../assets/properties.svg" />
        <span>
          {{ this.chore.propertyInternalName }}
        </span>
      </div>

      <div class="chore-cell-recurrence-days-container">
        <img class="chore-cell-clock-icon" src="../../assets/ClockIcon.svg" />
        <div class="chore-cell-recurrence-container">
          <div
            class="chore-cell-recurrence"
            v-if="this.selectedSpan == 'Daily'"
            :class="{
              'chore-cell-selected-recurrence': this.selectedSpan === 'Daily'
            }"
          >
            Daily
          </div>
          <div
            class="chore-cell-recurrence"
            v-else
            :class="{
              'chore-cell-selected-recurrence': this.selectedSpan === 'Weekly'
            }"
          >
            Weekly
          </div>
        </div>
        <div
          class="chore-cell-days-container"
          v-if="this.selectedSpan == 'Weekly'"
        >
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[0]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[0] }"
          >
            Sun
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[1]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[1] }"
          >
            Mon
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[2]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[2] }"
          >
            Tue
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[3]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[3] }"
          >
            Wed
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[4]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[4] }"
          >
            Thu
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[5]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[5] }"
          >
            Fri
          </div>
          <div
            class="chore-cell-day"
            v-if="this.selectedDays[6]"
            :class="{ 'chore-cell-selected-day': this.selectedDays[6] }"
          >
            Sat
          </div>
        </div>
      </div>

      <div ref="scrollList" :class="!readOnly ? 'scroll-list' : 'toggle-list'">
        <p class="chore-cell-schedule">Schedule</p>
        <div
          class="chore-cell-empty-placeholder"
          v-if="!this.assignments.length"
        >
          <div class="chore-cell-image-placeholder">
            <img src="../../assets/placeholderImage.svg" />
          </div>
          <div class="chore-cell-text-placeholder">
            There are no schedules for this task
          </div>
        </div>
        <ChoreCellhousemate
          v-for="assignment in this.assignments"
          :key="assignment.uuid"
          :assignment="assignment"
          v-on="$listeners"
          :readOnly="readOnly"
        />
      </div>
    </div>
    <div v-if="!choreToggled" class="chore-cell-toggle-card">
      <div>
        <span class="title">{{ this.chore.name }} {{ this.room }}</span>
        <span class="description">{{ this.chore.description }}</span>
      </div>
      <img
        src="../../assets/toggleButton.svg"
        @click="choreToggled = !choreToggled"
      />
    </div>
    <delete-popup
      v-if="selDeleteChore"
      @confirm="deleteChore()"
      @cancel="
        selDeleteChore = false
        popDown()
      "
      :thingName="'Chore'"
    />
  </div>
</template>

<script>
import ChoreCellhousemate from '@/components/tasks/ChoreCellHousemate.vue'
import calls from '@/api/calls'
import Housemate from '@/models/housemate'
import Assignment from '@/models/assignment'
import DeletePopup from '../../components/GenericDeletePopup.vue'
import { message } from 'ant-design-vue'
import { isAssignmentOnOrAfterCaliforniaToday } from '@/functions/choreDateFilter'

const daysArrMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }

export default {
  name: 'ChoreCell',
  components: {
    ChoreCellhousemate,
    DeletePopup
  },
  data() {
    return {
      selectedSpan: 'Daily',
      selectedDays: [0, 0, 0, 0, 0, 0, 0],
      selectedDaysOfMonth: [],
      assignments: [],
      popedUp: false,
      popUpStyleObj: {
        top: '0px',
        left: '0px'
      },
      selPopupOpt: -1,
      selDeleteChore: false,
      choreToggled: true,
      bodyHeight: 0
    }
  },
  props: {
    chore: Object,
    readOnly: Boolean,
    returnHousemates: Boolean
  },
  methods: {
    copyPublicLink() {
      const cleanPropertyName = this.chore.propertyInternalName.replace(
        / /g,
        ''
      )
      let publicLink = `${window.location.origin}/chores/publiclList?property=${cleanPropertyName}`
      navigator.clipboard.writeText(publicLink)
      message.info('Public link copied')
    },
    async deleteChore() {
      const { message, data } = await calls.DELETE(
        'chores',
        `${this.chore.uuid}`
      )
      if (data) {
        this.$emit('delete')
      }
    },
    updateElementHeight() {
      this.bodyHeight = document.body.clientHeight - 400
      const element = this.$refs.scrollList
      element.style.height = `${this.bodyHeight}px`
    },
    assignChore() {
      this.$emit('assign', { ...this.chore })
      this.popDown()
    },
    editChore() {
      this.$emit('edit', {
        ...this.chore,
        type: this.selectedSpan,
        recurrence: this.selectedDays
      })
      this.popDown()
    },
    popUp(event) {
      if (!this.popedUp) {
        this.popUpStyleObj.top = event.clientY + 8 + 'px'
        this.popUpStyleObj.left = event.clientX + 8 + 'px'
      } else {
        this.selPopupOpt = -1
      }
      this.popedUp = !this.popedUp
    },
    popDown() {
      if (!this.selDeleteChore) {
        this.selPopupOpt = -1
        this.popedUp = !this.popedUp
      }
    },
    selectOptionPopup(value) {
      if (this.selPopupOpt == value) {
        this.selPopupOpt = -1
      } else {
        this.selPopupOpt = value
      }
    },

    async loadAssignments() {
      if (this.returnHousemates === true) {
        this.choreHousemates = this.chore.housemates
      } else {
        const { message, data } = await calls.GET(
          'assignment/housemates',
          `${this.chore.uuid}`
        )
        this.choreHousemates = data
      }

      if (this.choreHousemates !== null) {
        for (let datum of this.choreHousemates) {
          let assignment = datum[0]
          if (!isAssignmentOnOrAfterCaliforniaToday(assignment.date)) continue
          let housemate = datum[1]
          this.assignments.push(
            new Assignment(
              this.chore,
              new Housemate(
                housemate.uuid,
                housemate.name,
                housemate.email,
                housemate.phone,
                housemate.roomName
              ),
              { ...assignment }
            )
          )
        }
      }
    }
  },
  beforeMount() {
    const cron = this.chore.schedule.split(' ')
    const dayOfMonth = cron[2]
    const dayOfWeek = cron[4]
    const divisionRegex = /\*\/[1-9]+\b/gi
    const selectionRegex = /([a-zA-Z],\s*)*[a-zA-Z]{1}/gi
    if (dayOfWeek == '*') {
      if (dayOfMonth == '*') {
        this.selectedSpan = 'Daily'
      } else {
        this.selectedSpan = 'Monthly'
      }
    } else {
      if (dayOfMonth != '*') {
        this.selectedSpan = 'Custom'
      } else {
        this.selectedSpan = 'Weekly'
      }
    }
    if (this.selectedSpan == 'Weekly') {
      let days
      if (dayOfWeek.match(divisionRegex)) {
        //TODO: add here logic to set the weekly format based on a */[0-9] cron tab specification (aka division regex)
      } else if (dayOfWeek.match(selectionRegex)) {
        days = dayOfWeek.split(',').map((el) => daysArrMap[el])
        for (let day of days) this.selectedDays[day] = 1
      }
    } else if (this.selectedSpan == 'Daily') {
      this.selectedDays = [1, 1, 1, 1, 1, 1, 1]
    } else if (this.selectedSpan == 'Monthly') {
      if (dayOfMonth.match(divisionRegex)) {
        //TODO: add here logic to set the weekly format based on a */[0-9] cron tab specification (aka division regex)
      } else if (dayOfMonth.match(selectionRegex)) {
        this.selectedDaysOfMonth = dayOfWeek
          .split(',')
          .map((el) => daysArrMap[el])
      }
    } else {
      //TODO: do something for custom dates
    }
    this.loadAssignments()
  },
  mounted() {
    this.updateElementHeight()
    window.addEventListener('resize', this.updateElementHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateElementHeight)
  }
}
</script>

<style scoped>
.chore-cell-delete-background {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.chore-cell-delete-container {
  background-color: white;
  width: 400px;
  height: 150px;
  position: relative;
  top: calc(50% - 150px);
  left: calc(50% - 200px);
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
}

.chore-cell-delete-title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #df000f;
  cursor: default;
}

.chore-cell-delete-subtitle {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  color: #192a3e;
  cursor: default;
}

.chore-cell-delete-button-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
}

.chore-cell-delete-button-yes,
.chore-cell-delete-button-no {
  width: 175px;
  height: 50px;
  border-radius: 4px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
}

.chore-cell-delete-button-yes {
  color: #ffffff;
  background: #df000f;
}
.chore-cell-delete-button-no {
  background: #ffffff;
  border: 1px solid #4a4a4a;
}

.cellBody {
  margin: 5px 10px 5px 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.cellButton {
  height: 32px;
  width: 45%;
  margin-top: 10px;
  font-size: 12px;
}
.sidebarBtnImg {
  height: 16px;
  width: 16px;
}
.sidebarBtnImgContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

.chore-cell-body {
  margin: 10px;
  padding: 18px 18px 5px 18px;
  width: 280px;
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  border: solid 0.5px #dfdfdf;
  background-color: #ffffff;
  position: relative;
}

.chore-cell-toggle-body {
  margin: 10px;
  padding: 18px;
  width: 280px;
  min-height: 500px;
  border-radius: 4px;
  box-shadow: 0 4px 16px 0 rgba(43, 45, 55, 0.05);
  border: solid 0.5px #dfdfdf;
  background-color: #ffffff;
  position: relative;
}

.chore-room-internal-name {
  border-top: solid 0.5px #dfdfdf;
  padding-top: 20px;
  padding-bottom: 10px;
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  display: flex;
}

.chore-room-internal-name span {
  display: block;
  padding-top: 5px;
  padding-left: 10px;
}

.chore-cell-options-popup {
  background-color: white;
  width: 77px;
  height: 87px;
  position: fixed;
  z-index: 1;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  padding: 8px;
}

.chore-cell-option {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
  display: flex;
  align-items: center;
  color: #767675;
  border-radius: 2px;
  cursor: pointer;
  width: 64px;
  height: 20px;
  padding: 4px;
}

.chore-cell-option-selected {
  background-color: #f0f8e8;
  font-weight: bold;
  color: #66b015;
}

.chore-cell-top-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}

.chore-cell-title {
  font-family: Montserrat;
  color: var(--rentalios-dark);
  font-size: 14px;
  font-style: normal;
  font-weight: bold;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 180px;
}

.chore-cell-options {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bolder;
  font-size: 20px;
  line-height: 20px;
  transform: rotate(180deg);
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.chore-cell-options:active {
  color: grey;
}

.chore-cell-description {
  margin: 0;
  padding: 0;
  text-align: left;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  margin: 12px 0 12px 0;
  min-height: 36px;
}

.chore-cell-schedule {
  margin: 0;
  padding: 0;
  text-align: left;
  font-family: Montserrat;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  margin: 12px 0 12px 0;
  font-weight: 900;
  color: #4a4a4a;
}

.chore-cell-recurrence-container,
.chore-cell-days-container {
  font-size: 12px;
}

.chore-cell-recurrence {
  width: 59px;
  height: 34px;
  margin: 12px 0px 12px 0px;
  border-radius: 4px;
  border: solid 0.5px #dfdfdf;
  color: #767675;
  font-size: 13px;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chore-cell-day {
  width: 44px;
  height: 32px;
  margin: 12px 10px 12px 0px;
  border-radius: 4px;
  border: solid 0.5px #dfdfdf;
  color: #767675;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chore-cell-selected-recurrence,
.chore-cell-selected-day {
  border-radius: 4px;
  border: none;
  background-color: #ebf0e6;
  color: var(--rentalios-dark);
  font-weight: bold;
}

.scroll-list,
.toggle-list {
  overflow: auto;
}

.toggle-list {
  height: 450px !important;
}

#cellButtonsContainer {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 5px;
  margin-bottom: 16px;
  border-top: solid 1px #f5f6f8;
}
#editButton {
  border-radius: 4px;
  border: solid 1px #109cf1;
  border-radius: 4px;
  background-color: #ffffff;
  color: #109cf1;
}
#editButton:hover {
  background-color: #f3fafe;
}
#deleteButton {
  border-radius: 4px;
  border: solid 1px #df000f;
  border-radius: 4px;
  background-color: #ffffff;
  color: #df000f;
}
#deleteButton:hover {
  background-color: rgba(223, 0, 15, 0.1);
}

.chore-cell-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.chore-cell-action {
  position: relative;
  cursor: pointer;
}

.chore-cell-action .tooltip {
  visibility: hidden;
  position: absolute;
  z-index: 10;
  background: #66b015;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  color: white;
  font-family: Montserrat;
  font-size: 10px;
  line-height: 14px;
  padding: 8px;
  top: -24px;
  right: 105%;
  white-space: nowrap;
}

.chore-cell-action:hover .tooltip {
  visibility: visible;
}

img.chore-cell-clock-icon {
  min-width: 18px;
  min-height: 18px;
  padding-left: 3px;
}

.chore-cell-recurrence-container {
  margin: 0 0 0 10px;
}

.chore-cell-recurrence-days-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: baseline;
  border-bottom: solid 0.5px #dfdfdf;
}

.chore-cell-days-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0 0 0 10px;
}

.chore-cell-image-placeholder {
  margin-top: 10%;
}

.chore-cell-text-placeholder {
  font-family: Montserrat;
  text-align: center;
  font-size: 12px;
  line-height: 18px;
  width: 50%;
  margin: 0 auto;
  padding-top: 5px;
}

.chore-cell-toggle-card {
  display: flex;
  flex-flow: row nowrap;
  width: 255px;
  height: 81px;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(43, 45, 55, 0.1);
  border-radius: 4px;
  margin: 10px;
}

.chore-cell-toggle-card div {
  display: flex;
  flex-flow: column nowrap;
  padding: 16px;
}

.chore-cell-toggle-card div span {
  text-align: left;
}

.chore-cell-toggle-card div span.title {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 14px;
  line-height: 19px;
  color: var(--rentalios-dark);
}

.chore-cell-toggle-card div span.description {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
  color: #767675;
}

.chore-cell-toggle-card img {
  min-width: 26px;
  min-height: 26px;
  padding: 4px;
}
</style>
